import { render, staticRenderFns } from "./CCheckboxGroup.vue?vue&type=template&id=2fc84558&scoped=true&"
import script from "./CCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CCheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CCheckboxGroup.vue?vue&type=style&index=0&id=2fc84558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc84558",
  null
  
)

export default component.exports